// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"7ac4b56c","845":"aed016ec","975":"3519581b"}[chunkId] + ".chunk.js";
};